import { slicedToArray as _slicedToArray } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import { Element } from 'slate';
import { Types } from './contants.js';
import { BLOCK_HTML_TAGS, VOID_ELEMENTS } from './index.js';

var setInline = function setInline(elName, editor) {
  var isInline = editor.isInline;

  editor.isInline = function (element) {
    return element.type === elName ? true : isInline(element);
  };

  return editor;
};
/**
 * @param editor
 * LINK PLUGIN
 */


function withLink(editor) {
  return setInline(Types.link, editor);
}
/**
 * @param editor
 * IMAGE PLUGIN
 */


function withImages(editor) {
  var isVoid = editor.isVoid;

  editor.isVoid = function (element) {
    return element.type === Types.image ? true : isVoid(element);
  };

  return editor;
}
/**
 * @param editor
 * NORMALIZATION OVERRIDE PLUGIN
 */


function withCustomNormalization(editor) {
  var normalizeNode = editor.normalizeNode; // overriding normalizer that breaks html

  editor.normalizeNode = function (entry) {
    var _entry = _slicedToArray(entry, 2),
        node = _entry[0],
        path = _entry[1];

    if (Element.isElement(node) && !editor.isInline(node)) return;
    if (path.length === 0) return;
    if (Element.isElement(node)) return;
    normalizeNode(entry);
  };

  var isInline = editor.isInline,
      isVoid = editor.isVoid;

  editor.isInline = function (element) {
    return BLOCK_HTML_TAGS.includes(element.type) ? false : isInline(element);
  };

  editor.isVoid = function (element) {
    return VOID_ELEMENTS.includes(element.type) || isVoid(element);
  };

  return editor;
}

export { withCustomNormalization, withImages, withLink };